import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page">
        <div className="min-h-80vh px-4 lg-px-27px xxl-px-89px">
          <div className="min-h-45px ml-full-width w-screen bg-f7f7f7 hidden md-block">
            <div className="breadcrumbs max-w-[1400px] mx-auto py-2 md-py-4">
              <Link to="/" onClick={toTop}>Home</Link>
              <span className="px-2">/</span>
              <span>Cart</span>
            </div>
          </div>

          <div className="cms-root_cmsFullWidth-5e3">
            <div className="cms-root-63a">
              <div className="richContent-root-63a">
                <div className="row-contained-645">
                  <div className="row-root-63a">
                    <div className="row-contained-inner">
                      <div className="text-root-63a">
                        <h1>Your Cart</h1>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="cart-empty">
                  <p className="cart-empty-text">Your cart is empty</p>
                  <Link to="/shop" onClick={toTop} className="continue-shopping-button">
                    Continue Shopping
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <div className="min-h-80vh px-4 lg-px-27px xxl-px-89px">
        <div className="min-h-45px ml-full-width w-screen bg-f7f7f7 hidden md-block">
          <div className="breadcrumbs max-w-[1400px] mx-auto py-2 md-py-4">
            <Link to="/" onClick={toTop}>Home</Link>
            <span className="px-2">/</span>
            <span>Cart</span>
          </div>
        </div>

        <div className="cms-root_cmsFullWidth-5e3">
          <div className="cms-root-63a">
            <div className="richContent-root-63a">
              <div className="row-contained-645">
                <div className="row-root-63a">
                  <div className="row-contained-inner">
                    <div className="text-root-63a">
                      <h1>Your Cart</h1>
                    </div>
                  </div>
                </div>
              </div>

              <div className="cart-content">
                <div className="cart-items">
                  {cartItems.map((item) => {
                    const product = getProductById(item.id);
                    if (!product) return null;
                    
                    return (
                      <div key={`${item.id}-${item.size}-${item.color}`} className="cart-item">
                        <div className="cart-item-image">
                          <img src={product.image} alt={product.name} />
                        </div>
                        <div className="cart-item-details">
                          <div className="cart-item-name">{product.name}</div>
                          <div className="cart-item-info">
                            {item.size && <span>Size: {item.size}</span>}
                            {item.color && <span>Color: {item.color}</span>}
                          </div>
                          <div className="cart-item-price">£{product.price}</div>
                          <div className="cart-item-quantity">
                            <button
                              className="quantity-button"
                              onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity - 1)}
                            >
                              -
                            </button>
                            <span className="quantity-value">{item.quantity}</span>
                            <button
                              className="quantity-button"
                              onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity + 1)}
                            >
                              +
                            </button>
                          </div>
                          <button
                            className="remove-button"
                            onClick={() => removeFromCart(item.id, item.size, item.color)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="cart-summary">
                  <div className="cart-summary-title">Order Summary</div>
                  <div className="cart-summary-item">
                    <span>Subtotal</span>
                    <span>£{subtotal.toFixed(2)}</span>
                  </div>
                  <div className="cart-summary-item">
                    <span>Shipping</span>
                    <span>Calculated at checkout</span>
                  </div>
                  <div className="cart-summary-total">
                    <span>Total</span>
                    <span>£{subtotal.toFixed(2)}</span>
                  </div>
                  <button className="checkout-button" onClick={handleCheckout}>
                    Proceed to Checkout
                  </button>
                  <Link to="/shop" onClick={toTop} className="continue-shopping-link">
                    Continue Shopping
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
